import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useRegisterModal } from "@/components/home/RegisterModalProvider";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#beneficios", label: "Beneficios" },
  { href: "#comparativo", label: "vs. Apps" },
  { href: "#precios", label: "Precios" },
  { href: "#como-funciona", label: "Cómo funciona" },
  { href: "#calculadora", label: "Calculadora" },
  { href: "#faq", label: "Preguntas" },
];

export const Navbar = () => {
  const { openModal } = useRegisterModal();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 bg-white/90 backdrop-blur-md transition-shadow ${scrolled ? "shadow-[0_2px_16px_rgba(255,102,18,0.12)]" : ""}`} data-testid="navbar">
      <div className="mt-container flex items-center justify-between h-16 lg:h-[72px]">
        <a href="#inicio" className="flex items-center" data-testid="nav-logo">
          <img src="/images/menuthere-logo-full-new.svg" alt="MenuThere" className="h-9" />
        </a>
        <nav className="hidden lg:flex items-center gap-7 text-[15px] font-medium text-gray-700">
          {LINKS.map((l) => <a key={l.href} href={l.href} className="hover:text-brand-orange transition-colors">{l.label}</a>)}
          <Link to="/guia" className="hover:text-brand-orange transition-colors" data-track="nav-guia" data-testid="nav-guia-link">Guía paso a paso</Link>
        </nav>
        <div className="hidden lg:block">
          <button onClick={() => openModal({ source: "plan" })} className="btn-mt btn-mt-primary !py-3 !px-6 !text-[15px]" data-track="nav-empezar" data-testid="nav-cta-button">Empezar gratis</button>
        </div>
        <button className="lg:hidden p-2 -mr-2 text-brand-carbon" onClick={() => setOpen(!open)} aria-label="Menú" data-testid="nav-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-orange-100 bg-white px-5 py-4 flex flex-col gap-4 text-base font-medium" data-testid="nav-mobile-menu">
          {LINKS.map((l) => <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-1">{l.label}</a>)}
          <Link to="/guia" onClick={() => setOpen(false)} className="py-1" data-track="nav-guia">Guía paso a paso</Link>
          <button onClick={() => { setOpen(false); openModal({ source: "plan" }); }} className="btn-mt btn-mt-primary" data-track="nav-empezar">Empezar gratis</button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
